module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/arrow-left-e90d3b810bcd2bc9d1664d658f9f136d.png";